/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import {ACCOUNT, RESET} from './mutation-types'

export default {
  [ACCOUNT] (state, decodedToken) {
    state.id = decodedToken.sub
    state.email = decodedToken.email
    state.firstName = decodedToken.given_name
    state.avatar = decodedToken.picture
    const metadata =
      decodedToken[process.env.AUTH0_METADATA_NAMESPACE] || {}
    if (metadata.role) {
      state.role = metadata.role
    }
  },

  [RESET] (state) {
    state.id = null
    state.email = null
    state.firstName = null
    state.avatar = null
    state.role = null
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/account/mutations.js